import { Logger } from './Logger';
import { IMessagingClient, LogLevel, ILog } from '@agoda/messaging-client';
import { MessageType } from '../messagingClient/MessageType';
import { LogEventLevel } from './LogEventLevel';
import { ADPTags } from '@services/types';
import { AppContextData } from '@contexts/app/AppContextData';

const applicationName = 'universal-login';

export class ADPLogger implements Logger {
    private readonly messagingClient: IMessagingClient;
    private readonly appContext: AppContextData;
    private readonly baseTags: ADPTags = {};

    constructor(messagingClient: IMessagingClient, appContext: AppContextData) {
        this.messagingClient = messagingClient;
        this.appContext = appContext;

        this.messagingClient.context({
            sessionId: this.appContext.sessionId,
            userId: this.appContext.userId,
        });

        const { appId, clientVersion, origin, machineName, userId, sessionId, correlationId } = appContext;
        const devicePlatformId = `${appContext.devicePlatformId}`;
        const whitelabelId = `${appContext.whitelabelId}`;
        this.baseTags = {
            appId,
            clientVersion,
            origin,
            machineName,
            userId,
            sessionId,
            devicePlatformId,
            whitelabelId,
            correlationId,
        };
    }

    public info(message: string, error?: any, tags?: ADPTags) {
        this.log(LogEventLevel.Information, message, error, tags);
    }

    public warning(message: string, error?: any, tags?: ADPTags) {
        this.log(LogEventLevel.Warning, message, error, tags);
    }

    public error(message: string, error?: any, tags?: ADPTags) {
        this.log(LogEventLevel.Error, message, error, tags);
    }

    public fatal(message: string, error?: any, tags?: ADPTags) {
        this.log(LogEventLevel.Fatal, message, error, tags);
    }

    private log(level: LogLevel, message: string, error?: any, tags?: ADPTags) {
        const messageContext: ILog = {
            level,
            message,
            applicationName,
            // optional params
            exceptionMessage: error?.message ?? undefined,
            exceptionType: error?.name ?? undefined,
            stackTrace: error?.stack ?? undefined,
            stringTags: !!tags ? { ...this.baseTags, ...tags } : { ...this.baseTags },
        };

        const msg = this.messagingClient.create(MessageType.Log, messageContext);
        this.messagingClient.send(msg);
    }
}
